module.exports = __webpack_public_path__ + "media/entities/2105-1828a553.png";